import {translations} from 'presentation/translations-new';

const {firstInstruction, secondInstruction, thirdInstruction} =
	translations['pt-br'].others.facialBiometric.initialInstructions;

const INSTRUCTION_ITEMS = [
	{
		title: firstInstruction.title,
		description: firstInstruction.description,
		iconName: 'id-card',
	},
	{
		title: secondInstruction.title,
		description: secondInstruction.description,
		iconName: 'camera',
	},
	{
		title: thirdInstruction.title,
		description: thirdInstruction.description,
		iconName: 'sun',
	},
];

export {INSTRUCTION_ITEMS};
